// Base URL of the customer-facing ordering app the table QR points to.
const QR_BASE_URL = 'https://menupos.app'

/**
 * Builds the value encoded in a table's QR code. The QR is generated on the
 * frontend (see TableCardQrCode), the backend no longer renders the image.
 * Returns undefined when the table id or restaurant id is missing, so the
 * preview falls back to the placeholder.
 *
 * Shape: https://menupos.app/restaurants/{restaurantId}/tables/{tableId}
 */
export function buildTableQrValue(tableId?: string): string | undefined {
  if (!tableId) return undefined
  const restaurantId = localStorage.getItem('restaurantId')
  if (!restaurantId) return undefined
  return `${QR_BASE_URL}/restaurants/${restaurantId}/tables/${tableId}`
}
